import React from "react";
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import PropTypes from "prop-types";

const spinIcon = (
    <LoadingOutlined
        style={{
            fontSize: 28,
        }}
        spin
    />
);

const SpinLoader = ({indicator = spinIcon,children, isLoading = false, message, className = '', ...props}) => {

    return (
        <Spin spinning={isLoading} indicator={indicator} wrapperClassName={className}>
            {children}
        </Spin>
    )
}

SpinLoader.propTypes = {
    isLoading: PropTypes.bool,
    message: PropTypes.any,
};

export default SpinLoader